import { GET_WEEKLY_RECORDS } from '../actions/types';
export default function (state = false, action) {
    switch (action.type) {
        case GET_WEEKLY_RECORDS:
            return action.payload;
        default:
            return state;
    }
}